/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.utils

fun stringProperty(params: dynamic, property: String): String {
  return (params[property]).toString()
}

fun intProperty(params: dynamic, property: String): Int {
  return (params[property]).toString().toInt()
}
